import React from 'react';
import { BankNameField } from './components/BankNameField';
import { RecipientNameField } from './components/RecipientNameField';

export const BankWirePanel: React.FC = () => {
    return (
        <>
            <h2 className='decorated'>Bank Wire Information</h2>
            <div className='field-section'>
                <div className='field-row'>
                    <BankNameField />
                    <RecipientNameField />
                </div>
            </div>
        </>
    );
};
